import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */

class ExPlanWrapper extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    static defaultProps = {
        content: [],
    };

    render() {
        // console.log('ExPlanWrapper=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const exPlanWrapper = item => {
            return (
                <div className={styles.exPlanWrapper} key={item.id}>
                    <a href={item.url} target="_blank">
                        <img src={item.thumbnail} alt="" title="" />
                        <p>{item.title}</p>
                    </a>
                </div>
            );
        };

        return (
            <div className={styles.box}>
                {content.length !== 0
                    ? content.map(item => {
                          return exPlanWrapper(item);
                      })
                    : null}
            </div>
        );
    }
}

export default errorBoundary(ExPlanWrapper);
